import { DEFAULT_TENANT_KEY, normalizeTenantHostname } from "./tenantConfig";

type ResolveTenantKeyRuntimeOptions = {
  hostname?: string;
  search?: string;
  isProduction?: boolean;
  nodeEnv?: string;
};

function resolveSearch(searchOverride?: string) {
  if (typeof searchOverride === "string") {
    return searchOverride;
  }
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.search || "";
}

function isProductionRuntime(options: ResolveTenantKeyRuntimeOptions) {
  if (typeof options.isProduction === "boolean") {
    return options.isProduction;
  }

  const explicitNodeEnv = options.nodeEnv;
  if (explicitNodeEnv) {
    return explicitNodeEnv === "production";
  }

  if (import.meta.env.PROD) {
    return true;
  }

  const runtimeProcess =
    typeof globalThis !== "undefined"
      ? (globalThis as { process?: { env?: { NODE_ENV?: string } } }).process
      : undefined;
  if (runtimeProcess?.env?.NODE_ENV === "production") {
    return true;
  }

  return false;
}

export function resolveTenantKeyRuntime(
  options: ResolveTenantKeyRuntimeOptions = {}
) {
  const hostnameInput =
    options.hostname ??
    (typeof window !== "undefined" ? window.location.hostname : "");
  const hostnameTenantKey = normalizeTenantHostname(hostnameInput);

  if (!isProductionRuntime(options)) {
    const tenantOverride = new URLSearchParams(resolveSearch(options.search)).get(
      "tenant"
    );
    const normalizedOverride = tenantOverride
      ? normalizeTenantHostname(tenantOverride)
      : "";
    if (normalizedOverride) {
      return normalizedOverride;
    }
  }

  return hostnameTenantKey || DEFAULT_TENANT_KEY;
}

export function buildTenantHeaders(tenantKey?: string) {
  const resolvedKey = normalizeTenantHostname(tenantKey || "");
  return {
    "X-Vetcan-Tenant": resolvedKey || resolveTenantKeyRuntime(),
  };
}
